import { render } from "./departments.vue?vue&type=template&id=4d45a9e8&ts=true"
import script from "./departments.vue?vue&type=script&lang=ts"
export * from "./departments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__